var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-save',{attrs:{"modelName":"Categoria","saveUrl":"checklist-categories/","id":_vm.$route.params.id,"operation":"put","backUrl":"/checklist-categories","icon":"fa-list-ul"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dffb64be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChecklistCategory/Edit.vue
// module id = null
// module chunks = 